/**
 * @module store/tax/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: get kindchallenge tax settings
 *
 * @returns {array}
 */
const taxSettings = state => state.taxSettings;


/**
 * Getter: Возвращает флаг, загружаются ли в текущий момент e-mails
 *
 * @returns {boolean}
 */
const isTaxSettingsLoading = state => state.isTaxSettingsLoading;


export default {
  taxSettings,
  isTaxSettingsLoading,
};
